export default __webpack_public_path__ + "static/media/AVLc.2aea6e98.svg";